import { defaultListFetchParams } from "misc/edmClient";
import { createContext, useEffect, useState } from "react";
import { SortPayload, useDataProvider } from "react-admin";

import {
  BackendDataContextPropsType,
  InputChoiceApiType,
  InputChoicesType,
  SettingsType,
  SettingType,
} from "./App.types";
import { InputChoicesContext } from "./BackendDataContext";

export const PublicSettingsContext = createContext<SettingsType>({} as SettingsType);

export default function PublicDataContext(props: BackendDataContextPropsType) {
  const { children } = props;

  const dataProvider = useDataProvider();
  const payload = {
    ...defaultListFetchParams,
    pagination: { page: 1, perPage: 1000 },
    sort: { field: "id", order: "DESC" } as SortPayload,
  };

  const [publicSettings, setPublicSettings] = useState<SettingsType>({} as SettingsType);
  const [inputChoices, setInputChoices] = useState<InputChoicesType>({} as InputChoicesType);

  const fetchPublicSettings = () =>
    dataProvider.getList<SettingType>("public_options", payload).then((res) => {
      const data = res.data.reduce((settings, current) => {
        settings[current.key] = current;
        return settings;
      }, {} as SettingsType);
      setPublicSettings(data);
    });

  const fetchPublicInputChoices = () =>
    dataProvider.getList<InputChoiceApiType>("input_choices", payload).then((res) => {
      const data = res.data.reduce((choices, current) => {
        choices[current.id] = current.values;
        return choices;
      }, {} as InputChoicesType);
      setInputChoices(data);
    });

  useEffect(() => {
    fetchPublicSettings();
    fetchPublicInputChoices();
  }, []);

  return (
    <PublicSettingsContext.Provider value={publicSettings}>
      <InputChoicesContext.Provider value={inputChoices}>{children}</InputChoicesContext.Provider>
    </PublicSettingsContext.Provider>
  );
}
